export const FuncionalidadePortalCliente = {
  CriacaoUsuario: 'CriacaoUsuario',
  RestauracaoUsuario: 'RestauracaoUsuario',
  AlteracaoPlanoUsuario: 'AlteracaoPlanoUsuario'
};
